import axios from "axios";
import Cookies from "js-cookie";
import store from "./../store";
import router from "./../router";
import { PAGE_NEED_AUTH } from "./../assets/constant.js";

const hostname = window.location.hostname;
const protocol = window.location.protocol;
let baseUrl = `${protocol}//${hostname}/api/`;
if (hostname === 'localhost' || hostname === '127.0.0.1') {
    // FE localhost nhưng BE chạy Laravel ở 8000
    baseUrl = 'http://127.0.0.1:8000/api/';
}
axios.defaults.baseURL = process.env.VUE_APP_API_URL || baseUrl;

// Request interceptor
axios.interceptors.request.use(request => {
    let token = null;
    token = Cookies.get("rsr-user-token");

    request.headers.common["Access-Control-Allow-Origin"] = "*";
    request.headers.common["Access-Control-Allow-Methods"] = "GET";

    if (token) {
        request.headers.common["Authorization"] = `Bearer ${token}`;
    }

    return request;
});

// Response interceptor
axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response.status === '401') {
            store.dispatch("auth/clearToken");
            if (PAGE_NEED_AUTH.includes(router.currentRoute.name)) {
                router.push("/admin/login").catch(err => {});
            }
        }
        return Promise.reject(error);
    }
);

export default axios;
